<template>
  <div class="mb-4">
    <label :for="label" class="block text-sm leading-5 font-medium text-gray-700 mb-1"
      >{{ label }} <span v-if="optional" class="text-xs text-gray-700">(optional)</span>
    </label>
    <div class="mt-1">
      <textarea
        :id="label"
        ref="textarea"
        v-model="textValue"
        autocomplete="off"
        class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md field-sizing-fixed"
        :placeholder="placeholder"
        :rows="rows"
        @input="$emit('update:modelValue', $event.target.value)"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: ['modelValue', 'label', 'placeholder', 'rows', 'optional'],
  data() {
    return {
      textValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.textValue = newVal;
    },
  },
  methods: {
    insertTextAtCursor(text) {
      const cleanText = text === 'Select a merge tag...' ? '' : text;

      const textarea = this.$refs.textarea;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const before = this.textValue.substring(0, start);
      const after = this.textValue.substring(end);

      this.textValue = before + cleanText + after;
      this.$emit('update:modelValue', this.textValue);

      this.$nextTick(() => {
        textarea.selectionStart = start + cleanText.length;
        textarea.selectionEnd = start + cleanText.length;
        textarea.focus();
      });
    },
  },
};
</script>
